// @flow
import PATHS from './paths';

export type SectionParentNames =
  | 'application'
  | 'creditAndCriminal'
  | 'documentation';

export type SectionNames =
  | 'welcomeAndQualify'
  | 'household'
  | 'wagesAndIncome'
  | 'assets'
  | 'deductions'
  | 'payments'
  | 'identifyingDetails'
  | 'creditCriminalCheck'
  | 'documentsAndUploads'
  | 'applicationSubmission';

const SECTION_NAMES = {
  WELCOME_AND_QUALIFY: 'welcomeAndQualify',
  // Application
  APPLICATION: 'application',
  HOUSEHOLD: 'household',
  WAGES_AND_INCOME: 'wagesAndIncome',
  ASSETS: 'assets',
  DEDUCTIONS: 'deductions',
  // Credit and Criminal
  CREDIT_AND_CRIMINAL: 'creditAndCriminal',
  PAYMENTS: 'payments',
  IDENTIFYING_DETAILS: 'identifyingDetails',
  CREDIT_CRIMINAL_CHECK: 'creditCriminalCheck',
  // Documentation
  DOCUMENTATION: 'documentation',
  SELF_IDENTIFICATION: 'selfIdentification',
  DOCUMENTS_AND_UPLOADS: 'documentsAndUploads',
  APPLICATION_SUBMISSION: 'applicationSubmission',
};

export const SECTION_PARENT_NAMES: SectionParentNames = {
  [SECTION_NAMES.APPLICATION]: SECTION_NAMES.APPLICATION,
  [SECTION_NAMES.CREDIT_AND_CRIMINAL]: SECTION_NAMES.CREDIT_AND_CRIMINAL,
  [SECTION_NAMES.DOCUMENTATION]: SECTION_NAMES.DOCUMENTATION,
};

export const PATH_TO_SECTION_MAP = {
  [PATHS.APPLICATION]: SECTION_NAMES.APPLICATION,
  [PATHS.ASSETS]: SECTION_NAMES.ASSETS,
  [PATHS.HOUSEHOLD]: SECTION_NAMES.HOUSEHOLD,
  [PATHS.WAGES_AND_INCOME]: SECTION_NAMES.WAGES_AND_INCOME,
  [PATHS.DEDUCTIONS]: SECTION_NAMES.DEDUCTIONS,

  [PATHS.VERIFICATION]: SECTION_NAMES.CREDIT_AND_CRIMINAL,
  [PATHS.PAYMENTS]: SECTION_NAMES.PAYMENTS,
  [PATHS.IDENTIFYING_DETAILS]: SECTION_NAMES.IDENTIFYING_DETAILS,
  [PATHS.CREDIT_CRIMINAL_CHECK]: SECTION_NAMES.CREDIT_CRIMINAL_CHECK,

  [PATHS.DOCUMENTATION]: SECTION_NAMES.DOCUMENTATION,
  [PATHS.SELF_IDENTIFICATION]: SECTION_NAMES.SELF_IDENTIFICATION,
  [PATHS.DOCUMENTS_AND_UPLOADS]: SECTION_NAMES.DOCUMENTS_AND_UPLOADS,
  [PATHS.APPLICATION_SUBMISSION]: SECTION_NAMES.APPLICATION_SUBMISSION,
};

export const SECTION_TO_PATH_MAP = {
  [SECTION_NAMES.WELCOME_AND_QUALIFY]: PATHS.WELCOME,

  [SECTION_NAMES.APPLICATION]: PATHS.APPLICATION,
  [SECTION_NAMES.HOUSEHOLD]: PATHS.HOUSEHOLD,
  [SECTION_NAMES.ASSETS]: PATHS.ASSETS,
  [SECTION_NAMES.WAGES_AND_INCOME]: PATHS.WAGES_AND_INCOME,
  [SECTION_NAMES.DEDUCTIONS]: PATHS.DEDUCTIONS,

  [SECTION_NAMES.CREDIT_AND_CRIMINAL]: PATHS.VERIFICATION,
  [SECTION_NAMES.PAYMENTS]: PATHS.PAYMENTS,
  [SECTION_NAMES.IDENTIFYING_DETAILS]: PATHS.IDENTIFYING_DETAILS,
  [SECTION_NAMES.CREDIT_CRIMINAL_CHECK]: PATHS.CREDIT_CRIMINAL_CHECK,

  [SECTION_NAMES.DOCUMENTATION]: PATHS.DOCUMENTATION,
  [SECTION_NAMES.SELF_IDENTIFICATION]: PATHS.SELF_IDENTIFICATION,
  [SECTION_NAMES.DOCUMENTS_AND_UPLOADS]: PATHS.DOCUMENTS_AND_UPLOADS,
  [SECTION_NAMES.APPLICATION_SUBMISSION]: PATHS.APPLICATION_SUBMISSION,
};

export default SECTION_NAMES;
